import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@fluentui/react-components";
import { forwardRef, lazy, Suspense } from "react";
/**
 * Creates a lazy component wrapper that only calls the async function to get the underlying component when the lazy component is actually mounted.
 * This allows deferring imports until they are needed. While the underlying component is being loaded, a spinner is displayed.
 * @param getComponentAsync A function that returns a promise resolving to the component.
 * @param defaultProps Options for the loading spinner.
 * @returns A React component that displays a spinner while loading the async component.
 */
export function MakeLazyComponent(getComponentAsync, defaultProps) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const LazyComponent = lazy(async () => {
        const component = await getComponentAsync();
        return { default: component };
    });
    return forwardRef((props, ref) => {
        const { spinnerSize = defaultProps?.spinnerSize, spinnerLabel = defaultProps?.spinnerLabel, ...rest } = props;
        const componentProps = { ...rest, ref };
        return (_jsx(Suspense, { fallback: _jsx(Spinner, { ref: ref, size: spinnerSize, label: spinnerLabel }), children: _jsx(LazyComponent, { ...componentProps }) }));
    });
}
//# sourceMappingURL=lazyComponent.js.map